import { useEffect, useState } from "react";

import { IsReactNative } from "@/utils/ReactNativeUtils";

export default function useIsReactNative() {
  const [isReactNative, setIsReactNative] = useState(false);

  useEffect(() => {
    setIsReactNative(IsReactNative());
  }, []);

  return isReactNative;
}
